import { render } from "./StoreMain.vue?vue&type=template&id=4dfa0730"
import script from "./StoreMain.vue?vue&type=script&lang=js"
export * from "./StoreMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__